import _ from 'lodash';
import { STATUSES, singletonAnswers } from '../constants';
export function validateDuration(status, duration) {
  if (status === STATUSES.COMPLETE) {
    return duration !== null && duration >= 1 && duration <= 99;
  }
  return true;
}
export function validateQuestionsAndAnswers(questions, screening) {
  var requiredAnswers = screening.questions.map(function (question) {
    return question.required && question.id;
  }).filter(Boolean);
  var answers = Object.keys(questions);
  var difference = _.difference(requiredAnswers, answers);
  return difference.length === 0;
}
export function validateRequiredQuestions(questions, screening, status, shouldValidateDuration, duration) {
  if (status === STATUSES.COMPLETE) {
    var areQuestionsValid = validateQuestionsAndAnswers(questions, screening);
    var isDurationValid = shouldValidateDuration ? validateDuration(duration) : true;
    return areQuestionsValid && isDurationValid;
  }
  return true;
}
export var hasSingletonAnswerError = function hasSingletonAnswerError(valueAnswer) {
  if (valueAnswer.length <= 1) return false;
  return singletonAnswers.some(function (sa) {
    return valueAnswer.indexOf(sa) !== -1;
  });
};
//# sourceMappingURL=validateRequiredQuestions.js.map